module.exports = __webpack_public_path__ + "media/images/social/pinterest-6c6977e2a0791993f2edcf5906b9f6f8.png";